import { setCookie, getCookie, deleteCookie } from '../functions';

const COOKIENAME = 'occ';

document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.dataLayer === 'undefined') {
        window.dataLayer = [];
    }

    const cookieConsent = getCookie(COOKIENAME);
    const $cookieContainer = document.querySelector('.cookie');

    if (!$cookieContainer) {
        return;
    }

    const $cookieBox = $cookieContainer.querySelector('.cookie-consent');
    const $toggleButton = $cookieContainer.querySelector('.cookie-toggle');

    const hideConsent = () => {
        if ($toggleButton) $toggleButton.classList.remove('is-hidden--soft');
        if ($cookieBox) $cookieBox.classList.add('is-hidden--soft');
    };

    const showConsent = () => {
        if ($cookieBox) $cookieBox.classList.remove('is-hidden--soft');
        if ($toggleButton) $toggleButton.classList.add('is-hidden--soft');
    };

    cookieConsent ? hideConsent() : showConsent();

    document.querySelectorAll('.cookie-choice').forEach(($button) => {
        $button.addEventListener('click', () => {
            const consent = $button.dataset?.consent === 'true';
            setCookie(COOKIENAME, consent, 365);
            window.parent.postMessage({ type: 'questionnaire:consent', cookie: consent ? 'true' : 'false' }, '*');
            hideConsent();
        });
    });

    if ($toggleButton) {
        $toggleButton.addEventListener('click', () => {
            deleteCookie(COOKIENAME);
            window.parent.postMessage({ type: 'questionnaire:consent', cookie: null }, '*');
            showConsent();
        });
    }

    window.addEventListener('message', (event) => {
        if (event.data?.type === 'questionnaire:consent') {
            if (event.data.cookie) {
                const consent = event.data.cookie === 'true';
                setCookie(COOKIENAME, consent, 365);
                hideConsent();
            }
        }
    });

    window.parent.postMessage({ type: 'questionnaire:ready' }, '*');
});
